import * as React from "react";

const SvgArrowDown = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="currentColor"
    viewBox="0 0 16 16"
  >
    <mask
      id="mask_arrow_down"
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="24"
      height="24"
    >
      <rect width="24" height="24" fill="currentColor" />
    </mask>
    <g mask="url(#mask_arrow_down)">
      <path d="M0 4L8 12L16 4H0Z" fill="currentColor" />
    </g>
  </svg>
);

export default SvgArrowDown;
